import { render } from "./CategoryProfile.vue?vue&type=template&id=32e80629&scoped=true"
import script from "./CategoryProfile.vue?vue&type=script&lang=js"
export * from "./CategoryProfile.vue?vue&type=script&lang=js"

import "./CategoryProfile.vue?vue&type=style&index=0&id=32e80629&lang=scss&scoped=true"
import "./CategoryProfile.vue?vue&type=style&index=1&id=32e80629&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e80629"]])

export default __exports__